export const TIME_COLORS = ["rgba(0, 0, 0, 0.1)", "#E1F7E1", "#96DF96", "#55ad55"];
export const CONSUMPTION_COLORS = ["rgba(0, 0, 0, 0.1)", "#81D4FA", "#0288D1", "#025285"];

export const TIME_COLORS_DARK = ["rgba(255, 255, 255, 0.1)", "#145214", "#2E8B2E", "#62C761"];
export const CONSUMPTION_COLORS_DARK = ["rgba(255, 255, 255, 0.1)", "#0277BD", "#0288D1", "#81D4FA"];

export const TIME_COLORS_SCALE = [...TIME_COLORS, "rgba(0, 0, 0, 0.05)"];
export const CONSUMPTION_COLORS_SCALE = [...CONSUMPTION_COLORS, "rgba(0, 0, 0, 0.05)"];

export const TIME_COLORS_SCALE_DARK = [...TIME_COLORS_DARK, "rgba(255, 255, 255, 0.05)"];
export const CONSUMPTION_COLORS_SCALE_DARK = [...CONSUMPTION_COLORS_DARK, "rgba(255, 255, 255, 0.05)"];

export const ACTIVATION_FEE_THRESHOLDS = {
  LOW: 0.5,
  MEDIUM: 1.5,
  HIGH: 2.5,
};

export const DURATION_FEE_THRESHOLDS = {
  LOW: 1.0,
  MEDIUM: 2.0,
  HIGH: 4.0,
};

export const CONSUMPTION_FEE_THRESHOLDS = {
  LOW: 0.1,
  MEDIUM: 0.25,
  HIGH: 0.5,
};

export const LEVELS = {
  NONE: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};
